module.exports = __webpack_public_path__ + "img/account-icon.928c32e9.svg";